import { render, staticRenderFns } from "./MerchantsEdit.vue?vue&type=template&id=0feb6af1&"
import script from "./MerchantsEdit.vue?vue&type=script&lang=ts&"
export * from "./MerchantsEdit.vue?vue&type=script&lang=ts&"
import style0 from "./MerchantsEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MerchantsEdit.vue"
export default component.exports